/* eslint-disable new-cap */
/* eslint-disable max-lines */
import React from 'react';
import Toggle from 'react-toggle';
import {Icon, Modal, Popup} from 'semantic-ui-react';
import {rucTDE, solNacDigits} from '../../../constants/commons';
import {UserGroup} from '../../../constants/userGroup';
import {completeWithCeros} from '../../../utils/commonUtils';
import {MultiSelectFilter} from '../table/TableFilters';

export const tableHeaderWithProps = ({
  isUserTde,
  dealerId,
  deleteFloatingInventory,
  putFloatingInventory,
  currentFlUserGroup,
  filters,
}) => {
  const availableColumns = {
    'Header': () => <span className="floating-header-title">DISPONIBLE</span>,
    'accessor': 'floatingVisible',
    'width': 150,
    'Cell': ({row}) => {
      const currentData = row.original;
      const handleChange = (data, newValue) => {
        const dataForQuery = {
          'floating_visible': newValue,
          'floating_state': newValue === 'S' ? 'D' : 'N',
        };
        putFloatingInventory(
          data.orderNumber,
          data.line,
          {
            'all': isUserTde ? 'S' : 'N',
            'data': dataForQuery,
            'updateClient': null,
            'dealerReservation': dealerId,
          },
          filters,
          'Se ha actualizado exitosamente'
        );
      };
      return (
        <Toggle
          disabled={!['D', 'N'].includes(currentData.floatingState) || currentFlUserGroup !== UserGroup.tdeUser}
          icons={false}
          checked={currentData.floatingVisible === 'S' ? true : false}
          onChange={(e) =>
            handleChange(currentData, e.target?.checked ? 'S' : 'N')
          }
        />
      );
    },
  };

  function filterIncludes(rows, id, filterValue) {
    return rows.filter((row) => {
      const rowValue = row.values[id];
      return filterValue.includes(rowValue);
    });
  }

  const restColumns = [
    {
      'Header': () => <span className="floating-header-title">DÍAS EN <br/> DEPÓSITO</span>,
      'accessor': 'daysInDeposit',
      'width': 150,
      'Cell': ({row}) => {
        const setBgColor = (row) => {
          if (row.original.daysOldDeposit > 90) {
            return 'red-color-floating';
          } else if (row.original.daysOldDeposit > 60) {
            return 'yellow-color-floating';
          }
          return 'green-color-floating';
        };
        const bgColor = setBgColor(row);
        return <div className={bgColor}>{row.original.daysInDeposit?.split('/')[0] || ''}</div>;
      },
    },
    {
      'Header': () => <span className="floating-header-title">ESTADO FLOTANTE</span>,
      'accessor': 'floatingStateText',
      'width': 150,
      'Filter': MultiSelectFilter,
      'filter': filterIncludes,
    },
    {
      'Header': () => (
        <span className="floating-header-title">SOL. NAC.</span>
      ),
      'accessor': 'solNacNumber',
      'width': 150,
      'Cell': ({row}) => (
        <>{`${row.original.floatingState === 'S' ?
          completeWithCeros(
            String(row.original.solNacNumber),
            solNacDigits) :
          ''}`}</>
      ),
    },
    {
      'Header': () => <span className="floating-header-title">CHASIS</span>,
      'accessor': 'chassis',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">PEDIDO</span>,
      'accessor': 'orderNumber',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">LÍNEA</span>,
      'accessor': 'line',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">SFX</span>,
      'accessor': 'sfx',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">DEALER</span>,
      'accessor': 'dealerName',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">DESCRIPCIÓN</span>,
      'accessor': 'description',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">CÉDULA CLIENTE</span>,
      'accessor': 'document',
      'width': 150,
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerReservation === dealerId) {
          return (
            <>{row.original.document}</>
          );
        }
        return <></>;
      },
    },
    {
      'Header': () => <span className="floating-header-title">NOMBRE CLIENTE</span>,
      'accessor': 'clientName',
      'width': 150,
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerReservation === dealerId) {
          return (
            <>{`${row.original.lastNames || ''} ${row.original.names || ''}`}</>
          );
        }
        return <></>;
      },
    },
    {
      'Header': () => <span className="floating-header-title">ASESOR</span>,
      'accessor': 'adviserName',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">FECHA LLEGADA</span>,
      'accessor': 'arrivalDate',
      'width': 150,
      'Cell': ({row}) => <>{row.original?.arrivalDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="floating-header-title">VALOR FOB</span>,
      'accessor': 'fobValue',
      'width': 150,
      'Cell': ({row}) => {
        const dollarUS = Intl.NumberFormat('de-DE');
        return <>{`$ ${row.original?.fobValue ? dollarUS.format(row.original?.fobValue) : ''}`}</>;
      },
    },
    {
      'Header': () => <span className="floating-header-title">COLOR EXTERNO</span>,
      'accessor': 'externalColor',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">CÓD. EXT.</span>,
      'accessor': 'externalColorId',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">AÑO MODELO</span>,
      'accessor': 'yearModel',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">IMPORTADOR</span>,
      'accessor': 'importerName',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">% EXONERACIÓN</span>,
      'accessor': 'exonerationPerc',
      'width': 150,
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerReservation === dealerId) {
          return (
            <>{row.original.exonerationPerc}</>
          );
        }
        return <></>;
      },
    },
    {
      'Header': () => <span className="floating-header-title">TIPO DE NEGOCIO</span>,
      'accessor': 'clientTypeText',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">AVANCE RESERVA</span>,
      'accessor': 'reserveAdvance',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <>
            <Popup
              trigger={
                <span>
                  {row?.original?.reserveAdvance}
                </span>
              }
              position="top center"
              size="small"
              disabled={!row?.original?.reserveAdvance}
              inverted
            >
              <Popup.Content style={{'fontSize': '9px'}}>
                <span>
                  {row?.original?.reserveAdvanceText}
                </span>
              </Popup.Content>
            </Popup>
          </>
        );
      },
    },
    {
      'Header': () => <span className="floating-header-title">OBSERVACIONES</span>,
      'accessor': 'observations',
      'width': 150,
      'className': 'cell-custom-inventory-models width-order-medium',
      'Cell': ({row}) => {
        return (
          <>
            <Popup
              trigger={
                <div className="dot">
                  {row.original?.observations?.split('\n').length || 0}
                </div>
              }
              position="top center"
              size="small"
              className="observations-popup"
              disabled={!row?.original?.observations?.length}
              inverted
            >
              <Popup.Content style={{'fontSize': '9px'}}>
                <table>
                  {row?.original?.observations
                    ?.split('\n')
                    .map((observation, index) => (
                      <span>
                        <th>{observation}</th>
                        <br />
                      </span>
                    ))}
                </table>
              </Popup.Content>
            </Popup>
          </>
        );
      },
    },
    {
      'Header': () => <span className="floating-header-title">FECHA RESERVA</span>,
      'accessor': 'reservationFloatingDate',
      'width': 150,
      'Cell': ({row}) => <>{row.original.reservationFloatingDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="floating-header-title">FECHA EST. LIQUIDACIÓN</span>,
      'accessor': 'estSaleDate',
      'width': 150,
      'Cell': ({row}) => <>{row.original.estSaleDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="floating-header-title">DESTINO</span>,
      'accessor': 'destinyText',
      'width': 150,
    },
    {
      'Header': () => <span className="floating-header-title">ELIMINAR</span>,
      'accessor': 'actionsId',
      'width': 150,
      'Cell': ({row}) => {
        const currentData = row.original;
        const currentState = row.original.floatingState;
        const handleClick = () => {
          deleteFloatingInventory(
            currentData.orderNumber,
            currentData.line,
            isUserTde ? 'S' : 'N',
            dealerId,
            filters,
            currentData.daysOldDeposit
          );
        };
        const enabled = ((['R', 'S'].includes(currentState) && dealerId === rucTDE) ||
          (currentState === 'R' && dealerId === currentData?.dealerReservation)) &&
          ([UserGroup.coachDealer, UserGroup.tdeUser].includes(currentFlUserGroup));
        return (
          <>
            {
              !enabled ? (
                <span className="link">
                  <Icon
                    className="material-icons"
                    disabled
                    name="trash"
                    size="big"
                  />
                </span>
              ) :
                (
                  <Modal
                    size={'mini'}
                    trigger={
                      <span className="link">
                        <Popup
                          disabled={!enabled}
                          trigger={
                            <span className="link">
                              <Icon
                                className="material-icons"
                                disabled={!enabled}
                                name="trash"
                                size="big"
                              />
                            </span>
                          }
                          content="Eliminar"
                          position="top center"
                          inverted
                        />
                      </span>
                    }
                    header={
                      `¿ESTÁ SEGURO QUE DESEA ELIMINAR LA ${
                        currentState === 'S' ? 'SOL. DE NACIONALIZACIÓN' : 'RESERVA'
                      } DE ESTA LÍNEA?`
                    }
                    actions={[
                      {'key': 'cancel', 'content': 'CANCELAR'},
                      {
                        'key': 'done',
                        'content': 'CONFIRMAR',
                        'positive': true,
                        'onClick': () => handleClick(),
                        'primary': true,
                      },
                    ]}
                  />
                )
            }
          </>
        );
      },
    },
  ];

  return isUserTde ? [availableColumns, ...restColumns] : restColumns;
};
